import { useSelector } from "react-redux";
import { Container1, Container3, Container4, Design1, TextBox, TextBox2, Wrapper } from "./style";
import { selectLanguage } from "redux/reducers/languageReducer";
import { useRef } from "react";
import { useScrollFadeIn } from "hooks/useScrollFadeIn";
const RecoveryCom1 = ({ t }) => {
  const language = useSelector(selectLanguage);
  const ref1 = useRef();
  useScrollFadeIn(ref1);
  return (
    <Wrapper ref={ref1} className="fade-in">
      <Container1>
        <img src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/cb109ac6UsingWallet_11.png" alt="phoneImg" />
      </Container1>
      <Container3>
        <TextBox language={language}>
          <div>{t("recover-1-1")}</div>
          <div>
            <span>{t("recover-1-2")} </span>
            <span>{t("recover-1-3")}</span>
          </div>
          <Container4>
            <TextBox2>
              <div>
                <img
                  src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/61830f91UsingWallet_12.svg"
                  alt="icon"
                />
              </div>
              <div>
                <span>{t("recover-1-4")}</span>
                <span>{t("recover-1-5")}</span>
              </div>
            </TextBox2>
            <TextBox2>
              <div>
                <img
                  src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/b32c010dUsingWallet_13.svg"
                  alt="icon"
                />
              </div>
              <div>
                <span>{t("recover-1-6")}</span>
                <span>{t("recover-1-7")}</span>
              </div>
            </TextBox2>
          </Container4>
        </TextBox>
      </Container3>
      <Design1></Design1>
    </Wrapper>
  );
};

export default RecoveryCom1;
